
import { SHOW_INFORMATION_SERVICE, CHANGE_CONTENT, ADD_OBSERVATIONS, FETCH_SERVICES, SHOW_MODAL_ADDITIONAL_DATA, RENDER_APPOINTMENT_OR_BUDGET } from './actions';
import {SUCCESSFUL_FETCHED_SERVICES} from '../../../actionTypes/service';

const initialState = {
  router: 'content',
  breadcrumb: '',
  content: null,
  services: [],
  isLoading: false,
  selectedService: null,
  modal: {
    show: false,
  },
  renderAppointmentOrBudget: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL_ADDITIONAL_DATA:
      return {
        ...state,
        modal: {
          show: action.payload.show,
        }
      }
    case SUCCESSFUL_FETCHED_SERVICES:
    case FETCH_SERVICES:
      return {
        ...state,
        ...action.payload,
      };

    case ADD_OBSERVATIONS:
      return {
        ...state,
        ...action.payload,
      };
    case CHANGE_CONTENT:
      let content = action.payload.content;
      let breadcrumb = state.breadcrumb.slice();
      if (content) {
        let key = action.payload.content.key;
        breadcrumb += (breadcrumb) ? ":" + key : key;
      } else {
        breadcrumb = '';
      }
      return {
        ...state,
        breadcrumb,
        content: action.payload.content,
        router: action.payload.router,
        selectedService: null,
      };
    case SHOW_INFORMATION_SERVICE:
      let selectedService = action.payload.selectedService;
      if (state.selectedService === selectedService)
        selectedService = null;
      return {
        ...state,
        selectedService,
      };
    case RENDER_APPOINTMENT_OR_BUDGET:
      return {
        ...state,
        renderAppointmentOrBudget: action.payload.renderAppointmentOrBudget,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/services/reducer.js